function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z"
});

const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48"
}, props), _ref);

export default SvgArrowRight;